export const getBaseRoute = 'https://suiterc.icareus.com/api';
